import request from "@/utils/request";

export const getPageColumn = (params = {}) => {
  return request({
    url: "/system/column/getPage",
    method: "post",
    data: params, // GET 请求参数
  });
};
// 查询详细
export function getColumnById(id) {
  return request({
    url: "/system/column/getById/" + id,
    method: "get",
  });
}

export const getPageContent = (params = {}) => {
  return request({
    url: "/system/content/getPage",
    method: "post",
    data: params, // GET 请求参数
  });
};
// 查询详细
export function getContentDetail(id) {
  return request({
    url: "/system/content/getById/" + id,
    method: "get",
  });
}
export function getConfigList(params) {
  return request({
    url: "system/config/list",
    method: "get",
    params,
  });
}
/**
 * 获取资质详情
 * @param {*} id
 * @returns
 */
export function getQualificationsItem(id) {
  return request({
    url: "system/certification/getById/" + id,
    method: "get",
  });
}
/**
 * 获取资质列表
 * @param {*} data 
 * @returns 
 */
export function getQualificationsList(data) {
  return request({
    url: "system/certification/getPage",
    method: "post",
    data,
  });
}
